import clientRequest from '@/lib/client-request';

export interface WechatQRCodeResponse {
  qrcode_url: string;
  event_key: string;
}

export function getWechatQRCode(
  referralCode: string | null,
  source?: string,
): Promise<DataResponse<WechatQRCodeResponse>> {
  return clientRequest.get('/wechat_mp/qrcode', {
    params: {
      referral_code: referralCode,
      source: source,
    },
  });
}

export interface WechatJSConfig {
  appId: string;
  nonceStr: string;
  timestamp: string;
  signature: string;
  url: string;
}

export function getWechatJSConfig(
  url: string,
): Promise<DataResponse<WechatJSConfig>> {
  return clientRequest.post('/wechat_mp/jssdk_config', {
    url,
  });
}

export function generateMiniProgramUrlLink(
  path: string,
  query: string,
): Promise<DataResponse<string>> {
  return clientRequest.post('/wechat_ma/generate_url_link', {
    path,
    query,
  });
}
